import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominaTimbresCancelar', {
    template: template,
    controller: NominaTimbresCancelarComponent,
    bindings: {
      idProyecto: '<',
      retenido: '<',
      idNomina: '<',
      data: '<',
      onChange: '&',
    },
  })

function NominaTimbresCancelarComponent() {
  let $ctrl = this
  $ctrl.$onChanges = $onChanges
  $ctrl.actualizar = actualizar
  $ctrl.autorizando = false
  $ctrl.confirmando = false

  function $onChanges(changes) {
    if (changes.data) {
      if ($ctrl.retenido) {
        $ctrl.data = []
      } else {
        $ctrl.data = $ctrl.data.filter(function (item) {
          return item.pendiente === false
            && item.status_pagado === true
            && item.status_timbrado === true
            && item.status_cancelacion === false
        })
      }

      $ctrl.omitidos = changes.data.currentValue.length - $ctrl.data.length
    }
  }

  function actualizar(data) {
    $ctrl.autorizando = false
    $ctrl.confirmando = false

    if (!data)
      return

    $ctrl.onChange({$event: {timbres: $ctrl.data, data: data}})
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/timbres/cancelar/component.js